import { createContext } from "react";

/**
 * The value passed into the `LoadingGroupContext` provider.
 */
export interface LoadingGroupContextValue {

  /**
   * Indicates whether loading.
   */
  readonly loading: boolean;
}

/**
 * The `LoadingGroup` context.
 */
export const LoadingGroupContext = createContext<LoadingGroupContextValue>({
  loading: false,
});
